import { render } from "./AssignmentIcon.vue?vue&type=template&id=f8a14fe8"
import script from "./AssignmentIcon.vue?vue&type=script&lang=js"
export * from "./AssignmentIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__